import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'

import img1 from '../../assets/eng1.svg'
import img2 from '../../assets/eng2.svg'
import img3 from '../../assets/eng3.svg'
import img4 from '../../assets/eng4.webp'
import { fadeIn, staggerContainer } from '../../utils/motion'

const EngagementSection = () => {

    const navigate = useNavigate()

    const data = [
        {
            title: 'Staff/Resource Augmentation',
            img: img1,
            desc: 'Our staff augmentation model is intended to help companies find the right skills for their project.'
        },
        {
            title: 'Product Development',
            img: img2,
            desc: 'The project-based model is designed to help you get your product built from ideation to deployment by a team of expert software engineering consultants.'
        },
        {
            title: 'Dedicated Development Team',
            img: img3,
            desc: 'Our team of developers is highly qualified and dedicated to delivering quality development services to clients.'
        },
    ]

    return (
        <div>
            <motion.div
                variants={staggerContainer}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
            >
                <div className="max-w-screen-2xl mx-auto px-5 py-6 md:py-10 ">
                    <motion.div
                        whileInView={{ opacity: [0, 1] }}
                        transition={{ duration: 1.0 }}>
                        <p className="text-2xl font-bold text-center dark:text-white">
                            Engagement{" "}
                            <span className="text-red-500">
                                Models
                            </span>
                        </p>
                    </motion.div>
                    <div className='grid grid-cols-1 lg:grid-cols-2 gap-5 lg:w-[90%] mx-auto mt-7'>
                        <div >
                            <h1 className='italic dark:text-white text-xs md:text-base text-center lg:text-left'>
                                We solve your biggest business pains and help you succeed.<br />Here is how we can work together
                            </h1>
                            <div className='w-[80%] md:w-full mx-auto'>
                                <img
                                    src={img4}
                                    alt='img'
                                    className='h-[300px] object-contain mt-3 md:mt-12 cursor-pointer'
                                    onClick={() => navigate('/contact-us')}
                                />
                            </div>
                        </div>
                        <div className='space-y-4'>
                            {data.map((item, i) => {

                                let x
                                if (i === 0) {
                                    x = 0.2
                                } else if (i === 1) {
                                    x = 0.4

                                } else if (i === 2) {
                                    x = 0.6
                                }
                                return <motion.div
                                    variants={fadeIn('left', 'tween', x, 1.3)}
                                    className='flex items-center justify-center group'
                                    key={i}
                                >
                                    <div
                                        onClick={() => navigate('/pricing')}
                                        className={`bg-white rounded-md cursor-pointer shadow-md min-h-[150px] dark:bg-slate-700 p-3 flex items-center gap-3 md:group-hover:translate-x-5 duration-[850ms]`} >
                                        <div>
                                            <img src={item.img} alt="img" className='h-[70px] w-[70px] group-hover:scale-110 duration-700' />
                                        </div>
                                        <div>
                                            <h1 className='font-bold dark:text-white text-[15px] sm:text-[17px]'>
                                                {item.title}
                                            </h1>
                                            <p className='mt-1 text-[12px] sm:text-[15px] text-gray-500 dark:text-gray-300'>{item.desc}</p>
                                        </div>
                                    </div>
                                </motion.div>
                            })}
                        </div>
                    </div>
                </div>
            </motion.div>
        </div>
    )
}

export default EngagementSection